import { createUserManager } from 'redux-oidc';
import Keys from './keys';

const userManagerConfig = {
  client_id: Keys.IDENTITY_SERVER.CLIENT_ID,
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
  post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/callback`,
  response_type: Keys.IDENTITY_SERVER.RESPONSE_TYPE,
  scope: Keys.IDENTITY_SERVER.SCOPE,
  authority: Keys.IDENTITY_SERVER.AUTHORITY,
  // silent_redirect_uri: `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}/silent_renew.html`,
  automaticSilentRenew: false,
  filterProtocolClaims: false,
  loadUserInfo: true,
};

const userManager = createUserManager(userManagerConfig);

export default userManager;
